export type HeaderNavItem = {
    label: string;
    to: string;
    active?: boolean;
};

export function isNavItemActive(item: HeaderNavItem, pathname: string): boolean {
    return item.active ?? (pathname === item.to || pathname.startsWith(`${item.to}/`));
}
